import {
  GET_USER_WALLETS_START,
  GET_USER_WALLETS_SUCCESS,
  GET_USER_WALLETS_ERROR,
} from 'constants/action-types/user/getUserWallets';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_USER_WALLETS_START:
      return {
        ...state,
        getUserWallets: {
          ...state.getUserWallets,
          loading: true,
          error: null,
          data: [],
        },
      };
    case GET_USER_WALLETS_SUCCESS:
      return {
        ...state,
        getUserWallets: {
          ...state.getUserWallets,
          loading: false,
          data: payload,
        },
      };
    case GET_USER_WALLETS_ERROR:
      return {
        ...state,
        getUserWallets: {
          ...state.getUserWallets,
          error: payload,
          loading: false,
        },
      };
    default:
      return null;
  }
};
